import { TextField } from '@mui/material'
import React, { Fragment } from 'react'
import Modal from '@mui/material/Modal';
import Box from '@mui/material/Box';
import { Paper, Typography } from '@mui/material';
import { actualizaDomiciliosCliente, actualizaInstalacionesCliente, obtenerEquiposPorInstalacion } from '../../../../redux/DucksAtencionACliente/ModuloConsultaDucks'
import { useDispatch, useSelector } from 'react-redux'
import { actualizarLoadingApp_true, actualizarLoadingApp_false } from '../../../../redux/AppDucks'
import estilos from './InstalacionesComponent.module.css'
import Button from '@mui/material/Button';
import { ThemeProvider, createTheme } from '@mui/material/styles';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import HistoryRoundedIcon from '@mui/icons-material/HistoryRounded';
import EngineeringIcon from '@mui/icons-material/Engineering';
import InventoryIcon from '@mui/icons-material/Inventory';
import ModalHistorialCambiosComponent from './ModalHistorialCambiosComponent';
import ModalEquipoInstalacionComponent from './ModalEquipoInstalacionComponent';
import ModalInventarioInstalacionComponent from './ModalInventarioInstalacionComponent';

function InstalacionesComponent(props) {

    const dispatch = useDispatch()
    const dataUser = useSelector(store => store.Usuario.user)
    const [editar, setEditar] = React.useState(false)
    console.log('props ', props)
    const [alias, setAlias] = React.useState(props?.data?.informaciongeneralinstalacioncliente.alias?.toUpperCase())
    const [calle, setCalle] = React.useState(props?.data?.informaciongeneralinstalacioncliente?.calle?.toUpperCase())
    const [numerointerior, setNumeroInterior] = React.useState((props?.data?.informaciongeneralinstalacioncliente?.numerointerior == '' || props?.data?.informaciongeneralinstalacioncliente?.numerointerior == undefined || props?.data?.informaciongeneralinstalacioncliente?.numerointerior == null) ? 'S/N' : props?.data?.informaciongeneralinstalacioncliente?.numerointerior?.toUpperCase())
    const [numeroexterior, setNumeroExterior] = React.useState((props?.data?.informaciongeneralinstalacioncliente?.numeroexterior == '' || props?.data?.informaciongeneralinstalacioncliente?.numeroexterior == undefined || props?.data?.informaciongeneralinstalacioncliente?.numerointerior == null) ? 'S/N' : props?.data?.informaciongeneralinstalacioncliente?.numeroexterior?.toUpperCase())
    const [colonia, setColonia] = React.useState(props?.data?.informaciongeneralinstalacioncliente?.colonia?.toUpperCase())
    const [localidad, setLocalidad] = React.useState(props?.data?.informaciongeneralinstalacioncliente?.localidad?.toUpperCase())
    const [municipioalcaldia, setMunicipioAlcaldia] = React.useState(props?.data?.informaciongeneralinstalacioncliente?.municipio?.toUpperCase())
    const [estado, setEstado] = React.useState(props?.data?.informaciongeneralinstalacioncliente?.estado?.toUpperCase())
    const [codigopostal, setCodigoPostal] = React.useState(props?.data?.informaciongeneralinstalacioncliente?.codigopostal?.toUpperCase())


    const [responsablesLegales, setResponsablesLegales] = React.useState(props?.data?.informaciongeneralinstalacioncliente?.responsablesdeinstalacioncliente)

    const [openModal, setOpenModal] = React.useState(false);
    const handleOpenModal = () => { setOpenModal(true) }
    const handleCloseModal = () => { setOpenModal(false) }

    //let aux = []
    //props?.data?.informaciongeneralinstalacioncliente?.responsablesdeinstalacioncliente?.map(responsable => {
    //    if (responsable?.responsablesdeinstalacionclientehistorial.length > 0)
    //    aux.push(responsable?.responsablesdeinstalacionclientehistorial)
    //})
    const [openModalHistorial, setOpenModalHistorial] = React.useState(false);
    const [openModalEquipo, setOpenModalEquipo] = React.useState(false);
    const [openModalInventario, setOpenModalInventario] = React.useState(false);
    const [dataHistorial, setDataHistorial] = React.useState(props?.data?.informaciongeneralinstalacioncliente?.informaciongeneralinstalacionclientehistorial);
    const handleModalHistorial = () => {
        setDataHistorial(props?.data?.informaciongeneralinstalacioncliente?.informaciongeneralinstalacionclientehistorial)
        setOpenModalHistorial(true)
    }

    const style = {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 450,
        height: 'fit-content',
        bgcolor: 'background.paper',
        boxShadow: 24,
        p: 4,
        borderRadius: '5px'
    };

    const theme = createTheme({
        palette: {
            primary: {
                main: "#EDB75A"
            },
            secondary: {
                main: "#DC3545"
            }
        },
        typography: {
            fontFamily: "Montserrat",
            textTransform: 'none',
            button: {
                fontSize: 16,
                fontWeight: 500,
                fontFamily: "Montserrat",
                textTransform: 'none'
            }
        }
    });

    const modalComponent = () => {
        return (
            <div>
                <Modal open={openModal} onClose={handleCloseModal} aria-labelledby="modal-modal-title"
                    aria-describedby="modal-modal-description">
                    <Box sx={style}>
                        <Typography id="modal-modal-description" component="h2" sx={{ mt: 0, fontFamily: 'Montserrat' }} className='text-center'>
                            <h3 className='text-center'><b>ADVERTENCIA</b></h3>
                            <p className='mt-3'>¿Está seguro que desea actualizar la información de la instalación seleccionada?</p>
                        </Typography>
                        <br />
                        <ThemeProvider theme={theme}>
                            <div className='row'>
                                <div className='col-6 col-md-6'>
                                    <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => { handleCloseModal() }}>Cancelar</Button>
                                </div>
                                <div className='col-6 col-md-6'>
                                    <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => { btnContinuar() }}>Continuar</Button>
                                </div>
                            </div>
                        </ThemeProvider>
                    </Box>
                </Modal>
            </div>
        )
    }

    const btnContinuar = async () => {
        await dispatch(actualizarLoadingApp_true())
        let dataInstalacion = {
            dataActualizar: {
                datacambio: {
                    calle: calle?.toUpperCase(), numerointerior: numerointerior, numeroexterior: numeroexterior, colonia: colonia, localidad: localidad?.toUpperCase(),
                    municipio: municipioalcaldia, estado: estado?.toUpperCase(), codigopostal: codigopostal, alias: alias,
                    idiformaciongeneralcliente: props?.data?.informaciongeneralinstalacioncliente.idiformaciongeneralcliente
                },
                idiformaciongeneralcliente: props?.data?.informaciongeneralinstalacioncliente.idiformaciongeneralcliente,
                usuariocambio: dataUser?.[0]?.usuario
            }, responsablesLegales: responsablesLegales, usuariocambio: dataUser?.[0]?.usuario
        }
        await dispatch(actualizaInstalacionesCliente(dataInstalacion))
        handleCloseModal()
        props?.setIsEdicionInstalaciones(true)
        setEditar(false)
        await dispatch(actualizarLoadingApp_false())
    }

    const handleResponsableChange = (index, field, value) => {
        const updatedResponsables = [...responsablesLegales];
        updatedResponsables[index] = {
            ...updatedResponsables[index],
            [field]: value?.toUpperCase(),
        };
        setResponsablesLegales(updatedResponsables);
    };

    return (
        <Fragment>
            <ThemeProvider theme={theme}>
                <div className={`${estilos.masterInfo}`}>
                    <div className={`${estilos.header}`} style={props?.data.isbaja ? { background: '#DC3545' } : { background: '#8ABE3E' }}>
                        <h4>{props?.data?.tipoanexo.descripcion.toUpperCase()}</h4>
                        <h5 style={{ marginTop: '2%' }}><b>Alias: </b>{(props?.data?.informaciongeneralinstalacioncliente.alias).toUpperCase()}</h5>
                    </div>
                    {!editar &&
                        <div style={{ margin: 0, padding: 0 }}>
                            {props?.data?.isbaja == false &&
                                <div style={{ display: 'flex', justifyContent: 'end', marginTop: '-3%', paddingRight: '2%', gap: '4px' }} >
                                    <Tooltip title="Ver equipo de instalación">
                                        <IconButton size="large" sx={{ p: 1 }} onClick={() => {
                                            if (props?.data?.idanexocliente) {
                                                dispatch(obtenerEquiposPorInstalacion(props?.data?.idanexocliente))
                                            }
                                            setOpenModalEquipo(true)
                                            if (props?.onVerEquipo) {
                                                props.onVerEquipo(props?.data)
                                            }
                                        }}>
                                            <EngineeringIcon fontSize="inherit" sx={{ color: '#2B2B2B' }} />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Ver inventario">
                                        <IconButton size="large" sx={{ p: 1 }} onClick={() => {
                                            setOpenModalInventario(true)
                                            if (props?.onVerInventario) {
                                                props.onVerInventario(props?.data)
                                            }
                                        }}>
                                            <InventoryIcon fontSize="inherit" sx={{ color: '#2B2B2B' }} />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Ver historial de cambios">
                                        <IconButton size="large" sx={{ p: 1 }} onClick={() => { handleModalHistorial() }}>
                                            <HistoryRoundedIcon fontSize="inherit" sx={{ color: '#2B2B2B' }} />
                                        </IconButton>
                                    </Tooltip>
                                </div>
                            }

                            <h6 style={{ marginTop: 0, marginLeft: '4%', textAlign: 'left' }} ><b>Ubicación:</b></h6>
                            <p style={{ margin: '4%', marginTop: 0, textAlign: 'justify' }}>{
                                props?.data?.informaciongeneralinstalacioncliente.calle + ', ' + props?.data?.informaciongeneralinstalacioncliente.numerointerior + ', ' +
                                props?.data?.informaciongeneralinstalacioncliente.numeroexterior + ', ' + props?.data?.informaciongeneralinstalacioncliente.colonia + ', ' +
                                props?.data?.informaciongeneralinstalacioncliente.localidad + ', ' + props?.data?.informaciongeneralinstalacioncliente.municipio + ', ' +
                                props?.data?.informaciongeneralinstalacioncliente.estado + ', ' + props?.data?.informaciongeneralinstalacioncliente.codigopostal}</p>
                            {props?.data?.informaciongeneralinstalacioncliente?.responsablesdeinstalacioncliente?.length > 0 &&
                                <h6 style={{ textAlign: 'left', marginLeft: '4%' }}><b>Responsables de instalación:</b></h6>
                            }
                            {props?.data?.informaciongeneralinstalacioncliente?.responsablesdeinstalacioncliente?.map(responsable =>
                                <div className='row mt-3' style={{ width: '95%', margin: 'auto' }} >
                                    <div className='col-12 col-md-5' style={{ wordWrap: 'break-word', textAlign: 'left' }} > {responsable.nombreresponsable.toUpperCase()} </div>
                                    <div className='col-12 col-md-2' style={{ wordWrap: 'break-word', textAlign: 'left' }} > {responsable.telefono} </div>
                                    <div className='col-12 col-md-5 pe-0' style={{ wordWrap: 'break-word', textAlign: 'left' }} > {responsable.correoelectronico} </div>
                                </div>
                            )}

                            {!props?.data?.isbaja && !editar && dataUser?.[0]?.idrol == 1 &&
                                <div className="col-md-12 mt-3">
                                    <Button variant="contained" color="primary" style={{ width: '65%' }} onClick={() => setEditar(true)}>Editar instalación</Button>
                                </div>
                            }
                        </div>
                    }
                    {editar &&
                        <div className='row' style={{ margin: 0, paddingLeft: '4%', paddingRight: '4%' }}>
                            <div className='col-12 col-md-12 pe-5 mb-5'>
                                <TextField id="standard-basic" label="Alias de instalación" variant="standard" fullWidth style={{ marginLeft: '2%', marginTop: '2%' }}
                                    value={alias?.toUpperCase()} onChange={e => setAlias(e.target.value?.toUpperCase())} />
                            </div>
                            <h6 style={{ textAlign: 'left' }}><b>Domicilio:</b></h6>
                            <div className='col-12 col-md-6 pe-5 ps-3'>
                                <TextField id="standard-basic" label="Calle" variant="standard" fullWidth style={{ marginLeft: '3%', marginTop: '2%' }}
                                    value={calle} onChange={e => setCalle(e.target.value?.toUpperCase())} />
                            </div>
                            <div className='col-12 col-md-6 pe-5 ps-3'>
                                <TextField id="standard-basic" label="Número Interior" variant="standard" fullWidth style={{ marginLeft: '3%', marginTop: '2%' }}
                                    value={numerointerior} onChange={e => setNumeroInterior(e.target.value?.toUpperCase())} />
                            </div>
                            <div className='col-12 col-md-6 pe-5 ps-3'>
                                <TextField id="standard-basic" label="Número Exterior" variant="standard" fullWidth style={{ marginLeft: '3%', marginTop: '2%' }}
                                    value={numeroexterior} onChange={e => setNumeroExterior(e.target.value?.toUpperCase())} />
                            </div>
                            <div className='col-12 col-md-6 pe-5 ps-3'>
                                <TextField id="standard-basic" label="Colonia" variant="standard" fullWidth style={{ marginLeft: '3%', marginTop: '2%' }}
                                    value={colonia} onChange={e => setColonia(e.target.value?.toUpperCase())} />
                            </div>
                            <div className='col-12 col-md-6 pe-5 ps-3'>
                                <TextField id="standard-basic" label="Localidad" variant="standard" fullWidth style={{ marginLeft: '3%', marginTop: '2%' }}
                                    value={localidad} onChange={e => setLocalidad(e.target.value?.toUpperCase())} />
                            </div>
                            <div className='col-12 col-md-6 pe-5 ps-3'>
                                <TextField id="standard-basic" label="Municipio" variant="standard" fullWidth style={{ marginLeft: '3%', marginTop: '2%' }}
                                    value={municipioalcaldia} onChange={e => setMunicipioAlcaldia(e.target.value?.toUpperCase())} />
                            </div>
                            <div className='col-12 col-md-6 pe-5 ps-3'>
                                <TextField id="standard-basic" label="Estado" variant="standard" fullWidth style={{ marginLeft: '3%', marginTop: '2%' }}
                                    value={estado} onChange={e => setEstado(e.target.value?.toUpperCase())} />
                            </div>
                            <div className='col-12 col-md-6 pe-5 ps-3 pb-5'>
                                <TextField id="standard-basic" label="Codigo Postal" variant="standard" fullWidth style={{ marginLeft: '3%', marginTop: '2%' }}
                                    value={codigopostal} onChange={e => setCodigoPostal(e.target.value?.toUpperCase())} />
                            </div>

                            {responsablesLegales?.length > 0 &&
                                <h6 style={{ textAlign: 'left' }}><b>Responsables de instalación:</b></h6>
                            }
                            {responsablesLegales?.map((responsable, index) =>
                                <div className='row mt-3' style={{ width: '100%', margin: 'auto' }} key={index}>
                                    <div className='col-12 col-md-5' style={{ wordWrap: 'break-word', textAlign: 'left' }} >
                                        <TextField id="standard-basic" label="Nombre responsable" variant="standard" fullWidth style={{ marginTop: '2%' }}
                                            value={responsable.nombreresponsable.toUpperCase()}
                                            onChange={(e) => handleResponsableChange(index, 'nombreresponsable', e.target.value?.toUpperCase())} />
                                    </div>
                                    <div className='col-12 col-md-2' style={{ wordWrap: 'break-word', textAlign: 'center' }} >
                                        <TextField id="standard-basic" label="Teléfono" variant="standard" fullWidth style={{ marginTop: '2%' }}
                                            value={responsable.telefono} onChange={(e) => handleResponsableChange(index, 'telefono', e.target.value)} />
                                    </div>
                                    <div className='col-12 col-md-5 pe-0' style={{ wordWrap: 'break-word', textAlign: 'left' }} >
                                        <TextField id="standard-basic" label="Correo electrónico" variant="standard" fullWidth style={{ marginTop: '2%' }}
                                            value={responsable.correoelectronico} onChange={(e) => handleResponsableChange(index, 'correoelectronico', e.target.value?.toLowerCase())} />
                                    </div>
                                </div>
                            )}
                            <div className='row mt-4'>
                                <div className='col-6 col-md-6 justify-content-center'>
                                    <Button variant="contained" color="secondary" style={{ width: '100%' }} onClick={() => setEditar(false)}>Cancelar</Button>
                                </div>
                                <div className='col-6 col-md-6 justify-content-center'>
                                    <Button variant="contained" color="primary" style={{ width: '100%' }} onClick={() => handleOpenModal()}>Guardar cambios</Button>
                                </div>
                            </div>
                        </div>

                    }
                </div>
            </ThemeProvider>
            {modalComponent()}
            {openModalHistorial && <ModalHistorialCambiosComponent setOpenModalHistorial={setOpenModalHistorial} dataHistorial={dataHistorial} apartado={props?.data?.tipoanexo?.descripcion} />}
            {openModalEquipo && <ModalEquipoInstalacionComponent open={openModalEquipo} handleClose={() => setOpenModalEquipo(false)} dataInstalacion={props?.data} />}
            {openModalInventario && <ModalInventarioInstalacionComponent open={openModalInventario} handleClose={() => setOpenModalInventario(false)} dataInstalacion={props?.data} />}
        </Fragment >
    )
}

export default InstalacionesComponent